import React, { useState, useContext,useEffect } from "react";
import {
  Box,
  Grid,
  MenuItem,
  TextField,
  Stack,
  InputLabel,
  Typography,
  Button,
  Tooltip,
  IconButton,
  Card,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { IncuranceActions } from "../../service/insurance.actions";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileSaver from "file-saver";
import Loading from "../common/Loading";

import "../../../../App.css";
import { GlobalContext } from  "../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import { useTranslation } from "react-i18next";
import CustomLoader from "../../../../util/component/CustomLoader";
import GenericFilterBox from "../common/GenericFilterBox";
import { IServerSideGetRowsParams } from "ag-grid-community";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import { GenericTitleHeader } from "../common/GenericTitleHeader";
import { ContextOperation } from "../../context/OperationContext";
import SectionHeader from "../../../../util/component/SectionHeader";
import AgGridOperationTable from "../common/AgGridOperationTable";

const InsuranceTable = () => {
  const [tableData, setTableData] = useState<any>([]);
  const [pageSize, setPageSize] = useState<number>(10);
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [length, setLength] = useState<number>(0);
  const [resetForm, setResetForm] = useState<boolean>(false);
  const [loading, setIsLoading] = useState<boolean>(false);
  const { dispatchGlobalData } = useContext(GlobalContext);
  const [gridApi, setGridApi] = useState<any>(null);
  const {tenant} = useContext(ContextOperation);
  const [dataForm, setData] = useState<any>({
    descr: "",
    code: "",
  });
  const { t } = useTranslation(["operation"]);
  const insuranceServise = IncuranceActions();
  let code: string;
  const columns: any = [
    {
      field: "descr",
      headerName: t("carRange.description"),
      flex: 1,
    },
    {
      field: "code",
      headerName: t("carRange.code"),
      flex: 1,
    },
    {
      field: "id",
      headerName: "Id",
      disableColumnMenu: true,
      hide: true,
      headerClassName: "titleOfHeader",
      flex: 1,
      sortable: false,
    },
  ];
  const handleChange = (event: any, type: any) => {
    setData({ ...dataForm, [type]: event.target.value });
  };

  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };
  function managerData(response: any) {
    
      let rows: any[] = [];
      response.data.content.forEach((element: any) => {
        let row = {
          code: element.code,
          descr: element.descr,
          id: element.id,
        };
        rows.push(row);
      });
      return rows;
    
  }
 
  const Search = (e:any) => {
    e.preventDefault();
    setResetForm(!resetForm);
    
  };

  const getInsuaranceQueryParams = () => {
    let descr = !!dataForm.descr? dataForm.descr.trim() : null;
    let code = !!dataForm.code? dataForm.code.trim() : null;
    setIsLoading(true);
    return {
      getRows: async (params: IServerSideGetRowsParams) => {
        const startRow = params.request.startRow ? params.request.startRow : 0;
        const endRow = params.request.endRow;
        let pageSize = 10;
        if (
          endRow !== null &&
          endRow !== undefined &&
          startRow !== null &&
          startRow !== undefined
        ) {
          pageSize = endRow - startRow;
        }
        const pageNumber = startRow / pageSize;
    insuranceServise
      .getInsuaranceQueryParams(pageNumber, pageSize,tenant, descr, code)
      .then((response: any) => {
        params.successCallback(
          managerData(response),
          response.data.totalElements
        );
        setLength(response.data.totalElements)
         
        setIsLoading(false);
      })
      .catch((error: any) => {
        if (error.response) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
                snackbar: {
                    message:(error.response.data.error),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                }
            }
        });
        setIsLoading(false);
        } else if (error.request) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
                snackbar: {
                    message:(t("networkErrorMessage")),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                }
            }
        });
        setIsLoading(false);
        } else {
          setIsLoading(false);
        }
       
      });
     
    }
  }
  };

  function exportInsurance() {
    setIsLoading(true);
    let descr = !!dataForm.descr? dataForm.descr.trim() : null;
    let code = !!dataForm.code? dataForm.code.trim() : null;
    insuranceServise
      .exportData(tenant,descr, code)
      .then((response) => {
        setIsLoading(false);
        const filename =
          response?.headers["content-disposition"].split("filename=")[1];
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, filename);
      });
  }

  useEffect(() => {
    if (gridApi) {
      gridApi.setServerSideDatasource(
    getInsuaranceQueryParams());
  }}, [gridApi, resetForm]);
  const reset = () => {
   
    setData({
      descr: "",
      code: "",
    });
    setResetForm(!resetForm);
  };
  return (
    <Box>
        <SectionHeader
            title={t("insurance.titleFirst") + " " + t("insurance.titleSecond")}
        />
      <Box >
        <form id="idInsuranceForm" onSubmit ={(e)=>Search(e)}>
        <GenericFilterBox  formId="idInsuranceForm" onReset={reset}>
          
              <Box>
                <TextField
                  fullWidth
                  variant="standard"
                  id="descr"
                  name="descr"
                  //placeholder={t("carRange.descriptionLabel")}
                  label={t("insurance.description")}
                  value={dataForm.descr}
                  onChange={(event:any) => handleChange(event, "descr")}
                  inputProps={{
                    pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                     onInput: (event:any) => { 
                      if (event.currentTarget.validity.patternMismatch) 
                     { event.currentTarget.setCustomValidity(t("vehicle.filterModal.regexMessage"))
                    }else {
                      event.currentTarget.setCustomValidity('')
                    }
                    }
                  }}
                />
              </Box>
           
              <Box>
                <TextField
                  fullWidth
                  id="code"
                  name="code"
                  defaultValue="Brand code"
                  //placeholder={t("carRange.codeLabel")}
                  label= {t("insurance.code")}
                  value={dataForm.code}
                  onChange={(event:any) => handleChange(event, "code")}
                  variant="standard"
                  inputProps={{
                    pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                     onInput: (event:any) => { 
                      if (event.currentTarget.validity.patternMismatch) 
                     { event.currentTarget.setCustomValidity(t("vehicle.filterModal.regexMessage"))
                    }else {
                      event.currentTarget.setCustomValidity('')
                    }
                    }
                  }}
                />
              </Box>
              </GenericFilterBox>
        </form>
      </Box>
      <Box className="carCrudOuterTableBox">
        <Box>
        <Card >
       
        
            <Box minHeight={46} pr={1} display="flex" justifyContent={'flex-end'} alignItems="center" >
            <Tooltip  title={t("tooltipTitle.download")}>
            <IconButton color="accent" disabled ={length === 0 ?true:false} onClick={exportInsurance}>
                <FileDownloadIcon/>
               </IconButton>
               </Tooltip>
          </Box>
         
        
        </Card>
        </Box>
        <Box>
          
        
         <AgGridOperationTable
            columnDefs={columns}
            onGridReady={onGridReady}
            cacheBlockSize={pageSize}
            serverSideInfiniteScroll={true}
            rowModelType={"serverSide"}
            totalElements={length}

            />
         
        </Box>
        {loading && <CustomLoader loading={loading}/>}
      </Box>
    </Box>
  );
};
export default InsuranceTable;
